// source: https://www.npmjs.com/package/vue-country-flag

export interface CountryDTO {
    countryName: string;
    alpha2: string;
    alpha3: string;
    flagCode: string;
}

export const countries = [
    {
        countryName: 'Afghanistan',
        alpha2: 'af',
        alpha3: 'afg',
        flagCode: '',
    },
    {
        countryName: 'Åland Islands',
        alpha2: 'ax',
        alpha3: 'ala',
        flagCode: '',
    },
    {
        countryName: 'Albania',
        alpha2: 'al',
        alpha3: 'alb',
        flagCode: '',
    },
    {
        countryName: 'Algeria',
        alpha2: 'dz',
        alpha3: 'dza',
        flagCode: '',
    },
    {
        countryName: 'American Samoa',
        alpha2: 'as',
        alpha3: 'asm',
        flagCode: '',
    },
    {
        countryName: 'Andorra',
        alpha2: 'ad',
        alpha3: 'and',
        flagCode: '',
    },
    {
        countryName: 'Angola',
        alpha2: 'ao',
        alpha3: 'ago',
        flagCode: '',
    },
    {
        countryName: 'Anguilla',
        alpha2: 'ai',
        alpha3: 'aia',
        flagCode: '',
    },
    {
        countryName: 'Antarctica',
        alpha2: 'aq',
        alpha3: 'ata',
        flagCode: '',
    },
    {
        countryName: 'Antigua and Barbuda',
        alpha2: 'ag',
        alpha3: 'atg',
        flagCode: '',
    },
    {
        countryName: 'Argentina',
        alpha2: 'ar',
        alpha3: 'arg',
        flagCode: '',
    },
    {
        countryName: 'Armenia',
        alpha2: 'am',
        alpha3: 'arm',
        flagCode: '',
    },
    {
        countryName: 'Aruba',
        alpha2: 'aw',
        alpha3: 'abw',
        flagCode: '',
    },
    {
        countryName: 'Australia',
        alpha2: 'au',
        alpha3: 'aus',
        flagCode: '',
    },
    {
        countryName: 'Austria',
        alpha2: 'at',
        alpha3: 'aut',
        flagCode: '',
    },
    {
        countryName: 'Azerbaijan',
        alpha2: 'az',
        alpha3: 'aze',
        flagCode: '',
    },
    {
        countryName: 'Bahamas',
        alpha2: 'bs',
        alpha3: 'bhs',
        flagCode: '',
    },
    {
        countryName: 'Bahrain',
        alpha2: 'bh',
        alpha3: 'bhr',
        flagCode: '',
    },
    {
        countryName: 'Bangladesh',
        alpha2: 'bd',
        alpha3: 'bgd',
        flagCode: '',
    },
    {
        countryName: 'Barbados',
        alpha2: 'bb',
        alpha3: 'brb',
        flagCode: '',
    },
    {
        countryName: 'Belarus',
        alpha2: 'by',
        alpha3: 'blr',
        flagCode: '',
    },
    {
        countryName: 'Belgium',
        alpha2: 'be',
        alpha3: 'bel',
        flagCode: '',
    },
    {
        countryName: 'Belize',
        alpha2: 'bz',
        alpha3: 'blz',
        flagCode: '',
    },
    {
        countryName: 'Benin',
        alpha2: 'bj',
        alpha3: 'ben',
        flagCode: '',
    },
    {
        countryName: 'Bermuda',
        alpha2: 'bm',
        alpha3: 'bmu',
        flagCode: '',
    },
    {
        countryName: 'Bhutan',
        alpha2: 'bt',
        alpha3: 'btn',
        flagCode: '',
    },
    {
        countryName: 'Bolivia (Plurinational State of)',
        alpha2: 'bo',
        alpha3: 'bol',
        flagCode: '',
    },
    {
        countryName: 'Bonaire, Sint Eustatius and Saba',
        alpha2: 'bq',
        alpha3: 'bes',
        flagCode: '',
    },
    {
        countryName: 'Bosnia and Herzegovina',
        alpha2: 'ba',
        alpha3: 'bih',
        flagCode: '',
    },
    {
        countryName: 'Botswana',
        alpha2: 'bw',
        alpha3: 'bwa',
        flagCode: '',
    },
    {
        countryName: 'Bouvet Island',
        alpha2: 'bv',
        alpha3: 'bvt',
        flagCode: '',
    },
    {
        countryName: 'Brazil',
        alpha2: 'br',
        alpha3: 'bra',
        flagCode: '',
    },
    {
        countryName: 'Virgin Islands (British)',
        alpha2: 'vg',
        alpha3: 'vgb',
        flagCode: '',
    },
    {
        countryName: 'British Indian Ocean Territory',
        alpha2: 'io',
        alpha3: 'iot',
        flagCode: '',
    },
    {
        countryName: 'Brunei Darussalam',
        alpha2: 'bn',
        alpha3: 'brn',
        flagCode: '',
    },
    {
        countryName: 'Bulgaria',
        alpha2: 'bg',
        alpha3: 'bgr',
        flagCode: '',
    },
    {
        countryName: 'Burkina Faso',
        alpha2: 'bf',
        alpha3: 'bfa',
        flagCode: '',
    },
    {
        countryName: 'Burundi',
        alpha2: 'bi',
        alpha3: 'bdi',
        flagCode: '',
    },
    {
        countryName: 'Cambodia',
        alpha2: 'kh',
        alpha3: 'khm',
        flagCode: '',
    },
    {
        countryName: 'Cameroon',
        alpha2: 'cm',
        alpha3: 'cmr',
        flagCode: '',
    },
    {
        countryName: 'Canada',
        alpha2: 'ca',
        alpha3: 'can',
        flagCode: '',
    },
    {
        countryName: 'Cabo Verde',
        alpha2: 'cv',
        alpha3: 'cpv',
        flagCode: '',
    },
    {
        countryName: 'Cayman Islands',
        alpha2: 'ky',
        alpha3: 'cym',
        flagCode: '',
    },
    {
        countryName: 'Central African Republic',
        alpha2: 'cf',
        alpha3: 'caf',
        flagCode: '',
    },
    {
        countryName: 'Chad',
        alpha2: 'td',
        alpha3: 'tcd',
        flagCode: '',
    },
    {
        countryName: 'Chile',
        alpha2: 'cl',
        alpha3: 'chl',
        flagCode: '',
    },
    {
        countryName: 'China',
        alpha2: 'cn',
        alpha3: 'chn',
        flagCode: '',
    },
    {
        countryName: 'Hong Kong',
        alpha2: 'hk',
        alpha3: 'hkg',
        flagCode: '',
    },
    {
        countryName: 'Macao',
        alpha2: 'mo',
        alpha3: 'mac',
        flagCode: '',
    },
    {
        countryName: 'Christmas Island',
        alpha2: 'cx',
        alpha3: 'cxr',
        flagCode: '',
    },
    {
        countryName: 'Cocos (Keeling) Islands',
        alpha2: 'cc',
        alpha3: 'cck',
        flagCode: '',
    },
    {
        countryName: 'Colombia',
        alpha2: 'co',
        alpha3: 'col',
        flagCode: '',
    },
    {
        countryName: 'Comoros',
        alpha2: 'km',
        alpha3: 'com',
        flagCode: '',
    },
    {
        countryName: 'Congo',
        alpha2: 'cg',
        alpha3: 'cog',
        flagCode: '',
    },
    {
        countryName: 'Congo, Democratic Republic of the',
        alpha2: 'cd',
        alpha3: 'cod',
        flagCode: '',
    },
    {
        countryName: 'Cook Islands',
        alpha2: 'ck',
        alpha3: 'cok',
        flagCode: '',
    },
    {
        countryName: 'Costa Rica',
        alpha2: 'cr',
        alpha3: 'cri',
        flagCode: '',
    },
    {
        countryName: "Côte d'Ivoire",
        alpha2: 'ci',
        alpha3: 'civ',
        flagCode: '',
    },
    {
        countryName: 'Croatia',
        alpha2: 'hr',
        alpha3: 'hrv',
        flagCode: '',
    },
    {
        countryName: 'Cuba',
        alpha2: 'cu',
        alpha3: 'cub',
        flagCode: '',
    },
    {
        countryName: 'Curaçao',
        alpha2: 'cw',
        alpha3: 'cuw',
        flagCode: '',
    },
    {
        countryName: 'Cyprus',
        alpha2: 'cy',
        alpha3: 'cyp',
        flagCode: '',
    },
    {
        countryName: 'Czechia',
        alpha2: 'cz',
        alpha3: 'cze',
        flagCode: '',
    },
    {
        countryName: 'Denmark',
        alpha2: 'dk',
        alpha3: 'dnk',
        flagCode: '',
    },
    {
        countryName: 'Djibouti',
        alpha2: 'dj',
        alpha3: 'dji',
        flagCode: '',
    },
    {
        countryName: 'Dominica',
        alpha2: 'dm',
        alpha3: 'dma',
        flagCode: '',
    },
    {
        countryName: 'Dominican Republic',
        alpha2: 'do',
        alpha3: 'dom',
        flagCode: '',
    },
    {
        countryName: 'Ecuador',
        alpha2: 'ec',
        alpha3: 'ecu',
        flagCode: '',
    },
    {
        countryName: 'Egypt',
        alpha2: 'eg',
        alpha3: 'egy',
        flagCode: '',
    },
    {
        countryName: 'El Salvador',
        alpha2: 'sv',
        alpha3: 'slv',
        flagCode: '',
    },
    {
        countryName: 'Equatorial Guinea',
        alpha2: 'gq',
        alpha3: 'gnq',
        flagCode: '',
    },
    {
        countryName: 'Eritrea',
        alpha2: 'er',
        alpha3: 'eri',
        flagCode: '',
    },
    {
        countryName: 'Estonia',
        alpha2: 'ee',
        alpha3: 'est',
        flagCode: '',
    },
    {
        countryName: 'Ethiopia',
        alpha2: 'et',
        alpha3: 'eth',
        flagCode: '',
    },
    {
        countryName: 'Falkland Islands (Malvinas)',
        alpha2: 'fk',
        alpha3: 'flk',
        flagCode: '',
    },
    {
        countryName: 'Faroe Islands',
        alpha2: 'fo',
        alpha3: 'fro',
        flagCode: '',
    },
    {
        countryName: 'Fiji',
        alpha2: 'fj',
        alpha3: 'fji',
        flagCode: '',
    },
    {
        countryName: 'Finland',
        alpha2: 'fi',
        alpha3: 'fin',
        flagCode: '',
    },
    {
        countryName: 'France',
        alpha2: 'fr',
        alpha3: 'fra',
        flagCode: '',
    },
    {
        countryName: 'French Guiana',
        alpha2: 'gf',
        alpha3: 'guf',
        flagCode: '',
    },
    {
        countryName: 'French Polynesia',
        alpha2: 'pf',
        alpha3: 'pyf',
        flagCode: '',
    },
    {
        countryName: 'French Southern Territories',
        alpha2: 'tf',
        alpha3: 'atf',
        flagCode: '',
    },
    {
        countryName: 'Gabon',
        alpha2: 'ga',
        alpha3: 'gab',
        flagCode: '',
    },
    {
        countryName: 'Gambia',
        alpha2: 'gm',
        alpha3: 'gmb',
        flagCode: '',
    },
    {
        countryName: 'Georgia',
        alpha2: 'ge',
        alpha3: 'geo',
        flagCode: '',
    },
    {
        countryName: 'Germany',
        alpha2: 'de',
        alpha3: 'deu',
        flagCode: '',
    },
    {
        countryName: 'Ghana',
        alpha2: 'gh',
        alpha3: 'gha',
        flagCode: '',
    },
    {
        countryName: 'Gibraltar',
        alpha2: 'gi',
        alpha3: 'gib',
        flagCode: '',
    },
    {
        countryName: 'Greece',
        alpha2: 'gr',
        alpha3: 'grc',
        flagCode: '',
    },
    {
        countryName: 'Greenland',
        alpha2: 'gl',
        alpha3: 'grl',
        flagCode: '',
    },
    {
        countryName: 'Grenada',
        alpha2: 'gd',
        alpha3: 'grd',
        flagCode: '',
    },
    {
        countryName: 'Guadeloupe',
        alpha2: 'gp',
        alpha3: 'glp',
        flagCode: '',
    },
    {
        countryName: 'Guam',
        alpha2: 'gu',
        alpha3: 'gum',
        flagCode: '',
    },
    {
        countryName: 'Guatemala',
        alpha2: 'gt',
        alpha3: 'gtm',
        flagCode: '',
    },
    {
        countryName: 'Guernsey',
        alpha2: 'gg',
        alpha3: 'ggy',
        flagCode: '',
    },
    {
        countryName: 'Guinea',
        alpha2: 'gn',
        alpha3: 'gin',
        flagCode: '',
    },
    {
        countryName: 'Guinea-Bissau',
        alpha2: 'gw',
        alpha3: 'gnb',
        flagCode: '',
    },
    {
        countryName: 'Guyana',
        alpha2: 'gy',
        alpha3: 'guy',
        flagCode: '',
    },
    {
        countryName: 'Haiti',
        alpha2: 'ht',
        alpha3: 'hti',
        flagCode: '',
    },
    {
        countryName: 'Heard Island and McDonald Islands',
        alpha2: 'hm',
        alpha3: 'hmd',
        flagCode: '',
    },
    {
        countryName: 'Holy See',
        alpha2: 'va',
        alpha3: 'vat',
        flagCode: '',
    },
    {
        countryName: 'Honduras',
        alpha2: 'hn',
        alpha3: 'hnd',
        flagCode: '',
    },
    {
        countryName: 'Hungary',
        alpha2: 'hu',
        alpha3: 'hun',
        flagCode: '',
    },
    {
        countryName: 'Iceland',
        alpha2: 'is',
        alpha3: 'isl',
        flagCode: '',
    },
    {
        countryName: 'India',
        alpha2: 'in',
        alpha3: 'ind',
        flagCode: '',
    },
    {
        countryName: 'Indonesia',
        alpha2: 'id',
        alpha3: 'idn',
        flagCode: '',
    },
    {
        countryName: 'Iran (Islamic Republic of)',
        alpha2: 'ir',
        alpha3: 'irn',
        flagCode: '',
    },
    {
        countryName: 'Iraq',
        alpha2: 'iq',
        alpha3: 'irq',
        flagCode: '',
    },
    {
        countryName: 'Ireland',
        alpha2: 'ie',
        alpha3: 'irl',
        flagCode: '',
    },
    {
        countryName: 'Isle of Man',
        alpha2: 'im',
        alpha3: 'imn',
        flagCode: '',
    },
    {
        countryName: 'Israel',
        alpha2: 'il',
        alpha3: 'isr',
        flagCode: '',
    },
    {
        countryName: 'Italy',
        alpha2: 'it',
        alpha3: 'ita',
        flagCode: '',
    },
    {
        countryName: 'Jamaica',
        alpha2: 'jm',
        alpha3: 'jam',
        flagCode: '',
    },
    {
        countryName: 'Japan',
        alpha2: 'jp',
        alpha3: 'jpn',
        flagCode: '',
    },
    {
        countryName: 'Jersey',
        alpha2: 'je',
        alpha3: 'jey',
        flagCode: '',
    },
    {
        countryName: 'Jordan',
        alpha2: 'jo',
        alpha3: 'jor',
        flagCode: '',
    },
    {
        countryName: 'Kazakhstan',
        alpha2: 'kz',
        alpha3: 'kaz',
        flagCode: '',
    },
    {
        countryName: 'Kenya',
        alpha2: 'ke',
        alpha3: 'ken',
        flagCode: '',
    },
    {
        countryName: 'Kiribati',
        alpha2: 'ki',
        alpha3: 'kir',
        flagCode: '',
    },
    {
        countryName: "Korea (Democratic People's Republic of)",
        alpha2: 'kp',
        alpha3: 'prk',
        flagCode: '',
    },
    {
        countryName: 'Korea, Republic of',
        alpha2: 'kr',
        alpha3: 'kor',
        flagCode: '',
    },
    {
        countryName: 'Kuwait',
        alpha2: 'kw',
        alpha3: 'kwt',
        flagCode: '',
    },
    {
        countryName: 'Kyrgyzstan',
        alpha2: 'kg',
        alpha3: 'kgz',
        flagCode: '',
    },
    {
        countryName: "Lao People's Democratic Republic",
        alpha2: 'la',
        alpha3: 'lao',
        flagCode: '',
    },
    {
        countryName: 'Latvia',
        alpha2: 'lv',
        alpha3: 'lva',
        flagCode: '',
    },
    {
        countryName: 'Lebanon',
        alpha2: 'lb',
        alpha3: 'lbn',
        flagCode: '',
    },
    {
        countryName: 'Lesotho',
        alpha2: 'ls',
        alpha3: 'lso',
        flagCode: '',
    },
    {
        countryName: 'Liberia',
        alpha2: 'lr',
        alpha3: 'lbr',
        flagCode: '',
    },
    {
        countryName: 'Libya',
        alpha2: 'ly',
        alpha3: 'lby',
        flagCode: '',
    },
    {
        countryName: 'Liechtenstein',
        alpha2: 'li',
        alpha3: 'lie',
        flagCode: '',
    },
    {
        countryName: 'Lithuania',
        alpha2: 'lt',
        alpha3: 'ltu',
        flagCode: '',
    },
    {
        countryName: 'Luxembourg',
        alpha2: 'lu',
        alpha3: 'lux',
        flagCode: '',
    },
    {
        countryName: 'North Macedonia',
        alpha2: 'mk',
        alpha3: 'mkd',
        flagCode: '',
    },
    {
        countryName: 'Madagascar',
        alpha2: 'mg',
        alpha3: 'mdg',
        flagCode: '',
    },
    {
        countryName: 'Malawi',
        alpha2: 'mw',
        alpha3: 'mwi',
        flagCode: '',
    },
    {
        countryName: 'Malaysia',
        alpha2: 'my',
        alpha3: 'mys',
        flagCode: '',
    },
    {
        countryName: 'Maldives',
        alpha2: 'mv',
        alpha3: 'mdv',
        flagCode: '',
    },
    {
        countryName: 'Mali',
        alpha2: 'ml',
        alpha3: 'mli',
        flagCode: '',
    },
    {
        countryName: 'Malta',
        alpha2: 'mt',
        alpha3: 'mlt',
        flagCode: '',
    },
    {
        countryName: 'Marshall Islands',
        alpha2: 'mh',
        alpha3: 'mhl',
        flagCode: '',
    },
    {
        countryName: 'Martinique',
        alpha2: 'mq',
        alpha3: 'mtq',
        flagCode: '',
    },
    {
        countryName: 'Mauritania',
        alpha2: 'mr',
        alpha3: 'mrt',
        flagCode: '',
    },
    {
        countryName: 'Mauritius',
        alpha2: 'mu',
        alpha3: 'mus',
        flagCode: '',
    },
    {
        countryName: 'Mayotte',
        alpha2: 'yt',
        alpha3: 'myt',
        flagCode: '',
    },
    {
        countryName: 'Mexico',
        alpha2: 'mx',
        alpha3: 'mex',
        flagCode: '',
    },
    {
        countryName: 'Micronesia (Federated States of)',
        alpha2: 'fm',
        alpha3: 'fsm',
        flagCode: '',
    },
    {
        countryName: 'Moldova, Republic of',
        alpha2: 'md',
        alpha3: 'mda',
        flagCode: '',
    },
    {
        countryName: 'Monaco',
        alpha2: 'mc',
        alpha3: 'mco',
        flagCode: '',
    },
    {
        countryName: 'Mongolia',
        alpha2: 'mn',
        alpha3: 'mng',
        flagCode: '',
    },
    {
        countryName: 'Montenegro',
        alpha2: 'me',
        alpha3: 'mne',
        flagCode: '',
    },
    {
        countryName: 'Montserrat',
        alpha2: 'ms',
        alpha3: 'msr',
        flagCode: '',
    },
    {
        countryName: 'Morocco',
        alpha2: 'ma',
        alpha3: 'mar',
        flagCode: '',
    },
    {
        countryName: 'Mozambique',
        alpha2: 'mz',
        alpha3: 'moz',
        flagCode: '',
    },
    {
        countryName: 'Myanmar',
        alpha2: 'mm',
        alpha3: 'mmr',
        flagCode: '',
    },
    {
        countryName: 'Namibia',
        alpha2: 'na',
        alpha3: 'nam',
        flagCode: '',
    },
    {
        countryName: 'Nauru',
        alpha2: 'nr',
        alpha3: 'nru',
        flagCode: '',
    },
    {
        countryName: 'Nepal',
        alpha2: 'np',
        alpha3: 'npl',
        flagCode: '',
    },
    {
        countryName: 'Netherlands',
        alpha2: 'nl',
        alpha3: 'nld',
        flagCode: '',
    },
    {
        countryName: 'New Caledonia',
        alpha2: 'nc',
        alpha3: 'ncl',
        flagCode: '',
    },
    {
        countryName: 'New Zealand',
        alpha2: 'nz',
        alpha3: 'nzl',
        flagCode: '',
    },
    {
        countryName: 'Nicaragua',
        alpha2: 'ni',
        alpha3: 'nic',
        flagCode: '',
    },
    {
        countryName: 'Niger',
        alpha2: 'ne',
        alpha3: 'ner',
        flagCode: '',
    },
    {
        countryName: 'Nigeria',
        alpha2: 'ng',
        alpha3: 'nga',
        flagCode: '',
    },
    {
        countryName: 'Niue',
        alpha2: 'nu',
        alpha3: 'niu',
        flagCode: '',
    },
    {
        countryName: 'Norfolk Island',
        alpha2: 'nf',
        alpha3: 'nfk',
        flagCode: '',
    },
    {
        countryName: 'Northern Mariana Islands',
        alpha2: 'mp',
        alpha3: 'mnp',
        flagCode: '',
    },
    {
        countryName: 'Norway',
        alpha2: 'no',
        alpha3: 'nor',
        flagCode: '',
    },
    {
        countryName: 'Oman',
        alpha2: 'om',
        alpha3: 'omn',
        flagCode: '',
    },
    {
        countryName: 'Pakistan',
        alpha2: 'pk',
        alpha3: 'pak',
        flagCode: '',
    },
    {
        countryName: 'Palau',
        alpha2: 'pw',
        alpha3: 'plw',
        flagCode: '',
    },
    {
        countryName: 'Palestine, State of',
        alpha2: 'ps',
        alpha3: 'pse',
        flagCode: '',
    },
    {
        countryName: 'Panama',
        alpha2: 'pa',
        alpha3: 'pan',
        flagCode: '',
    },
    {
        countryName: 'Papua New Guinea',
        alpha2: 'pg',
        alpha3: 'png',
        flagCode: '',
    },
    {
        countryName: 'Paraguay',
        alpha2: 'py',
        alpha3: 'pry',
        flagCode: '',
    },
    {
        countryName: 'Peru',
        alpha2: 'pe',
        alpha3: 'per',
        flagCode: '',
    },
    {
        countryName: 'Philippines',
        alpha2: 'ph',
        alpha3: 'phl',
        flagCode: '',
    },
    {
        countryName: 'Pitcairn',
        alpha2: 'pn',
        alpha3: 'pcn',
        flagCode: '',
    },
    {
        countryName: 'Poland',
        alpha2: 'pl',
        alpha3: 'pol',
        flagCode: '',
    },
    {
        countryName: 'Portugal',
        alpha2: 'pt',
        alpha3: 'prt',
        flagCode: '',
    },
    {
        countryName: 'Puerto Rico',
        alpha2: 'pr',
        alpha3: 'pri',
        flagCode: '',
    },
    {
        countryName: 'Qatar',
        alpha2: 'qa',
        alpha3: 'qat',
        flagCode: '',
    },
    {
        countryName: 'Réunion',
        alpha2: 're',
        alpha3: 'reu',
        flagCode: '',
    },
    {
        countryName: 'Romania',
        alpha2: 'ro',
        alpha3: 'rou',
        flagCode: '',
    },
    {
        countryName: 'Russian Federation',
        alpha2: 'ru',
        alpha3: 'rus',
        flagCode: '',
    },
    {
        countryName: 'Rwanda',
        alpha2: 'rw',
        alpha3: 'rwa',
        flagCode: '',
    },
    {
        countryName: 'Saint Barthélemy',
        alpha2: 'bl',
        alpha3: 'blm',
        flagCode: '',
    },
    {
        countryName: 'Saint Helena, Ascension and Tristan da Cunha',
        alpha2: 'sh',
        alpha3: 'shn',
        flagCode: '',
    },
    {
        countryName: 'Saint Kitts and Nevis',
        alpha2: 'kn',
        alpha3: 'kna',
        flagCode: '',
    },
    {
        countryName: 'Saint Lucia',
        alpha2: 'lc',
        alpha3: 'lca',
        flagCode: '',
    },
    {
        countryName: 'Saint Martin (French part)',
        alpha2: 'mf',
        alpha3: 'maf',
        flagCode: '',
    },
    {
        countryName: 'Saint Pierre and Miquelon',
        alpha2: 'pm',
        alpha3: 'spm',
        flagCode: '',
    },
    {
        countryName: 'Saint Vincent and the Grenadines',
        alpha2: 'vc',
        alpha3: 'vct',
        flagCode: '',
    },
    {
        countryName: 'Samoa',
        alpha2: 'ws',
        alpha3: 'wsm',
        flagCode: '',
    },
    {
        countryName: 'San Marino',
        alpha2: 'sm',
        alpha3: 'smr',
        flagCode: '',
    },
    {
        countryName: 'Sao Tome and Principe',
        alpha2: 'st',
        alpha3: 'stp',
        flagCode: '',
    },
    {
        countryName: 'Saudi Arabia',
        alpha2: 'sa',
        alpha3: 'sau',
        flagCode: '',
    },
    {
        countryName: 'Senegal',
        alpha2: 'sn',
        alpha3: 'sen',
        flagCode: '',
    },
    {
        countryName: 'Serbia',
        alpha2: 'rs',
        alpha3: 'srb',
        flagCode: '',
    },
    {
        countryName: 'Seychelles',
        alpha2: 'sc',
        alpha3: 'syc',
        flagCode: '',
    },
    {
        countryName: 'Sierra Leone',
        alpha2: 'sl',
        alpha3: 'sle',
        flagCode: '',
    },
    {
        countryName: 'Singapore',
        alpha2: 'sg',
        alpha3: 'sgp',
        flagCode: '',
    },
    {
        countryName: 'Sint Maarten (Dutch part)',
        alpha2: 'sx',
        alpha3: 'sxm',
        flagCode: '',
    },
    {
        countryName: 'Slovakia',
        alpha2: 'sk',
        alpha3: 'svk',
        flagCode: '',
    },
    {
        countryName: 'Slovenia',
        alpha2: 'si',
        alpha3: 'svn',
        flagCode: '',
    },
    {
        countryName: 'Solomon Islands',
        alpha2: 'sb',
        alpha3: 'slb',
        flagCode: '',
    },
    {
        countryName: 'Somalia',
        alpha2: 'so',
        alpha3: 'som',
        flagCode: '',
    },
    {
        countryName: 'South Africa',
        alpha2: 'za',
        alpha3: 'zaf',
        flagCode: '',
    },
    {
        countryName: 'South Georgia and the South Sandwich Islands',
        alpha2: 'gs',
        alpha3: 'sgs',
        flagCode: '',
    },
    {
        countryName: 'South Sudan',
        alpha2: 'ss',
        alpha3: 'ssd',
        flagCode: '',
    },
    {
        countryName: 'Soviet Union',
        alpha2: 'su',
        alpha3: 'sun',
        flagCode: '',
    },
    {
        countryName: 'Spain',
        alpha2: 'es',
        alpha3: 'esp',
        flagCode: '',
    },
    {
        countryName: 'Sri Lanka',
        alpha2: 'lk',
        alpha3: 'lka',
        flagCode: '',
    },
    {
        countryName: 'Sudan',
        alpha2: 'sd',
        alpha3: 'sdn',
        flagCode: '',
    },
    {
        countryName: 'Suriname',
        alpha2: 'sr',
        alpha3: 'sur',
        flagCode: '',
    },
    {
        countryName: 'Svalbard and Jan Mayen',
        alpha2: 'sj',
        alpha3: 'sjm',
        flagCode: '',
    },
    {
        countryName: 'Eswatini',
        alpha2: 'sz',
        alpha3: 'swz',
        flagCode: '',
    },
    {
        countryName: 'Sweden',
        alpha2: 'se',
        alpha3: 'swe',
        flagCode: '',
    },
    {
        countryName: 'Switzerland',
        alpha2: 'ch',
        alpha3: 'che',
        flagCode: '',
    },
    {
        countryName: 'Syrian Arab Republic',
        alpha2: 'sy',
        alpha3: 'syr',
        flagCode: '',
    },
    {
        countryName: 'Taiwan, Province of China',
        alpha2: 'tw',
        alpha3: 'twn',
        flagCode: '',
    },
    {
        countryName: 'Tajikistan',
        alpha2: 'tj',
        alpha3: 'tjk',
        flagCode: '',
    },
    {
        countryName: 'Tanzania, United Republic of',
        alpha2: 'tz',
        alpha3: 'tza',
        flagCode: '',
    },
    {
        countryName: 'Thailand',
        alpha2: 'th',
        alpha3: 'tha',
        flagCode: '',
    },
    {
        countryName: 'Timor-Leste',
        alpha2: 'tl',
        alpha3: 'tls',
        flagCode: '',
    },
    {
        countryName: 'Togo',
        alpha2: 'tg',
        alpha3: 'tgo',
        flagCode: '',
    },
    {
        countryName: 'Tokelau',
        alpha2: 'tk',
        alpha3: 'tkl',
        flagCode: '',
    },
    {
        countryName: 'Tonga',
        alpha2: 'to',
        alpha3: 'ton',
        flagCode: '',
    },
    {
        countryName: 'Trinidad and Tobago',
        alpha2: 'tt',
        alpha3: 'tto',
        flagCode: '',
    },
    {
        countryName: 'Tunisia',
        alpha2: 'tn',
        alpha3: 'tun',
        flagCode: '',
    },
    {
        countryName: 'Turkey',
        alpha2: 'tr',
        alpha3: 'tur',
        flagCode: '',
    },
    {
        countryName: 'Turkmenistan',
        alpha2: 'tm',
        alpha3: 'tkm',
        flagCode: '',
    },
    {
        countryName: 'Turks and Caicos Islands',
        alpha2: 'tc',
        alpha3: 'tca',
        flagCode: '',
    },
    {
        countryName: 'Tuvalu',
        alpha2: 'tv',
        alpha3: 'tuv',
        flagCode: '',
    },
    {
        countryName: 'Uganda',
        alpha2: 'ug',
        alpha3: 'uga',
        flagCode: '',
    },
    {
        countryName: 'Ukraine',
        alpha2: 'ua',
        alpha3: 'ukr',
        flagCode: '',
    },
    {
        countryName: 'United Arab Emirates',
        alpha2: 'ae',
        alpha3: 'are',
        flagCode: '',
    },
    {
        countryName: 'United Kingdom of Great Britain and Northern Ireland',
        alpha2: 'gb',
        alpha3: 'gbr',
        flagCode: '',
    },
    {
        countryName: 'United States of America',
        alpha2: 'us',
        alpha3: 'usa',
        flagCode: '',
    },
    {
        countryName: 'United States Minor Outlying Islands',
        alpha2: 'um',
        alpha3: 'umi',
        flagCode: '',
    },
    {
        countryName: 'Uruguay',
        alpha2: 'uy',
        alpha3: 'ury',
        flagCode: '',
    },
    {
        countryName: 'Uzbekistan',
        alpha2: 'uz',
        alpha3: 'uzb',
        flagCode: '',
    },
    {
        countryName: 'Vanuatu',
        alpha2: 'vu',
        alpha3: 'vut',
        flagCode: '',
    },
    {
        countryName: 'Venezuela (Bolivarian Republic of)',
        alpha2: 've',
        alpha3: 'ven',
        flagCode: '',
    },
    {
        countryName: 'Viet Nam',
        alpha2: 'vn',
        alpha3: 'vnm',
        flagCode: '',
    },
    {
        countryName: 'Virgin Islands (U.S.)',
        alpha2: 'vi',
        alpha3: 'vir',
        flagCode: '',
    },
    {
        countryName: 'Wallis and Futuna',
        alpha2: 'wf',
        alpha3: 'wlf',
        flagCode: '',
    },
    {
        countryName: 'Western Sahara',
        alpha2: 'eh',
        alpha3: 'esh',
        flagCode: '',
    },
    {
        countryName: 'Yemen',
        alpha2: 'ye',
        alpha3: 'yem',
        flagCode: '',
    },
    {
        countryName: 'Zambia',
        alpha2: 'zm',
        alpha3: 'zmb',
        flagCode: '',
    },
    {
        countryName: 'Zimbabwe',
        alpha2: 'zw',
        alpha3: 'zwe',
        flagCode: '',
    },
    {
        countryName: 'Catalonia',
        alpha2: '',
        alpha3: '',
        flagCode: 'es-ca',
    },
    {
        countryName: 'England',
        alpha2: '',
        alpha3: '',
        flagCode: 'gb-eng',
    },
    {
        countryName: 'Europe',
        alpha2: '',
        alpha3: '',
        flagCode: 'eu',
    },
    {
        countryName: 'Galles',
        alpha2: '',
        alpha3: '',
        flagCode: 'gb-wls',
    },
    {
        countryName: 'Kosovo',
        alpha2: '',
        alpha3: '',
        flagCode: 'xk',
    },
    {
        countryName: 'Scotland',
        alpha2: '',
        alpha3: '',
        flagCode: 'gb-sct',
    },
    {
        countryName: 'United Nations',
        alpha2: '',
        alpha3: '',
        flagCode: 'un',
    },
];
